<template>
  <div id="app">
    <Header />
    <transition name="fade" mode="out-in">
      <keep-alive :include="'Home'">
        <router-view />
      </keep-alive>
    </transition>
    <Letterstripe />
    <Footer />
  </div>
</template>

<script>
import Letterstripe from "@/components/Letterstripe.vue";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";

export default {
  name: "App",
  data: function () {
    return {};
  },
  // metaInfo() {
  //   return {
  //     title: "Letter Art, Typography and Street Photography with love",
  //     meta: [
  //       {
  //         name: "description",
  //         content: "Typography infused street photography. Explore the map, create, and share your unique piece - or get it delivered and spark up your living space with it!",
  //       },
  //       { vmid: "og:title", property: "og:title", content: "Letter Art, Typography and Street Photography with love" },
  //       { vmid: "og:description", property: "og:description", content: "Typography infused street photography. Explore the map, create, and share your unique piece - or get it delivered and spark up your living space with it!" },
  //       // { property: "og:site_name", content: "cityphography" },
  //       // { property: "og:type", content: "website" },
  //       { name: "robots", content: "index,follow" },
  //     ],
  //   };
  // },
  components: {
    Letterstripe,
    Footer,
    Header,
  },
  mounted(){
    if(this.$store.state.theme == 'dark'){
      document.documentElement.classList.add('dark')
      document.body.classList.add('os-theme-light')
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/normalize.scss";
@import "@/assets/css/main.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
